import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "hiddenInput"];
  static values = { keywords: Array };

  connect() {
    this.updateDisplay();
  }

  keywordsValueChanged() {
    this.updateDisplay();
  }

  addKeyword() {
    const keyword = this.inputTarget.value.trim();
    if (keyword && !this.keywordsValue.includes(keyword)) {
      this.keywordsValue = [...this.keywordsValue, keyword];
      this.inputTarget.value = "";
      this.updateHiddenInput();
    }
  }

  removeKeyword(event) {
    const keyword = event.currentTarget.dataset.keyword;
    this.keywordsValue = this.keywordsValue.filter((k) => k !== keyword);
    this.updateHiddenInput();
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.addKeyword();
    }
  }

  updateDisplay() {
    if (this.keywordsValue.length === 0) {
      this.listTarget.innerHTML = `
        <div class="text-sm text-gray-500 py-2">
          No keywords added yet. Add keywords to monitor for in webhook payloads.
        </div>
      `;
    } else {
      this.listTarget.innerHTML = `
        <div class="flex flex-wrap gap-2">
          ${this.keywordsValue
            .map((keyword) => this.createKeywordBadge(keyword))
            .join("")}
        </div>
      `;

      // Reattach event listeners for remove buttons
      this.listTarget
        .querySelectorAll('[data-action="click->keyword-list#removeKeyword"]')
        .forEach((button) => {
          button.addEventListener("click", this.removeKeyword.bind(this));
        });
    }
  }

  createKeywordBadge(keyword) {
    return `
      <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
        ${this.escapeHtml(keyword)}
        <button type="button" 
                class="ml-1.5 -mr-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none"
                data-keyword="${this.escapeHtml(keyword)}"
                data-action="click->keyword-list#removeKeyword">
          <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </span>
    `;
  }

  updateHiddenInput() {
    this.hiddenInputTarget.value = JSON.stringify(this.keywordsValue);
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
